module.exports = __webpack_public_path__ + "img/13.45ed380d.jpg";